<div class="text-xs text-center">
  <app-privacy-policy class="block m-b-12"></app-privacy-policy>
  <p class="text-secondary">
    © 2016–{{ currentYear }} Joymo AS. All Rights Reserved.
  </p>
</div>
